import styled from 'styled-components';
import arrowLeft from 'assets/img/icons/arrowLeft.svg';
import arrowRight from 'assets/img/icons/closeMenu.svg';


export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: ${({ isOpen }) => (!isOpen && 'center')};
  width: ${({ isOpen }) => (isOpen ? '350px' : '60px')};
  min-height: 450px;
  box-shadow: ${({ isOpen }) => (isOpen && '-20px 0px 20px -5px rgba(0, 0, 0, 0.12)')};
  /* transition: 0.3s width ease; */
  margin-right: 10px;
  padding-top: 10px;
  background: #fff;
  border: 1px solid #EEEEEE;
  border-radius: 4px;

  position: absolute;
  z-index: 100;

  right: 0;
`;

export const Toggle = styled.button`
  border: 0; 
  outline: 0;
  background: ${({ isOpen }) => (isOpen ? `url(${arrowRight})` : `url(${arrowLeft})`)} no-repeat center center;
  width: 20px;
  height: 20px;
  background-size: cover;
  margin-bottom: 70px;

  :hover{
    opacity: 0.6;
  }

  :focus {
    outline: 0 !important;
  }
`;

export const IconOpt = styled.span`
  background: url(${({ icon }) => icon}) no-repeat center center;
  background-size: cover;
  width: 16px;
  height: 16px;
  margin-bottom: 36px;
  opacity: 0.5;

  :hover{
    opacity: 0.6;
  }
`;

export const Menu = styled.div`
  display: flex;
  height: 100%;
  width: ${({ fixed }) => (fixed ? '50px' : '300px')};
  flex-direction: column;
  padding: 15px;
`;

export const Title = styled.h3`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;  
`;

export const VerticalLine = styled.div`
  border: 1px solid #EEEEEE; 
  height: 95%;
  width: 1px;
  margin: 20px 0 20px 0;
`;

export const Date = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 16px;
  color: #A1A1A1;
  margin-bottom: 40px;
`;

export const ManageTask = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ iAmManaging, adminTask }) => (iAmManaging || adminTask ? '12px' : '11px')};
  line-height: 18px;
  margin-bottom: 0px;
  color: ${({ isManaging }) => (isManaging ? '#565656' : '#3E81F7')};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ pointer }) => pointer && 'cursor: pointer'};
  ${({ hover }) => hover && '&:hover { text-decoration-line: underline; }'};
`;

export const ManageAdmin = styled.span`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  color: #979797;
  width: 110px;
`;

export const Scheduler = styled.span`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  background: transparent;
  color: #FF7700;
  margin: 0 0 10px 0;
  padding:10px;
  border: 1px solid #DDD;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
 `;

export const SchedulerDate = styled.span`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  border-radius: 20px;

  &:hover{ 
    cursor: pointer;
    opacity: .7;
  }
 `;
